import React from "react";
import { useTranslation } from "react-i18next";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import { SECTION } from "./Document";
import { asTitle } from "utils/Utils";

interface DocumentTabsProps {
	activeTab: SECTION;
	hideDashboard?: boolean;
	onSelectTab(selectedTab: SECTION): void;
}

const DocumentTabs: React.FC<DocumentTabsProps> = (
	props: DocumentTabsProps
) => {
	const { t } = useTranslation();

	return (
		<Tabs
			sx={{ displayPrint: "none", marginBottom: 2 }}
			value={props.activeTab}
			onChange={(event, value): void => props.onSelectTab(value)}
			indicatorColor="primary"
			textColor="primary"
			centered>
			{!props.hideDashboard && (
				<Tab
					value={SECTION.DASHBOARD}
					label={asTitle(t("dashboard"))}
				/>
			)}
			<Tab value={SECTION.FIELDS} label={asTitle(t("information"))} />
			<Tab value={SECTION.EVALUATION} label={asTitle(t("evaluation"))} />
			<Tab value={SECTION.REPORTS} label={asTitle(t("report_other"))} />
			<Tab value={SECTION.ACCESS} label={asTitle(t("right_other"))} />
		</Tabs>
	);
};

export default DocumentTabs;
